export type { LinkPrimitiveProps, LinkProps, PostHogComDocsURL } from './Link'
export { Link, LinkPrimitive } from './Link'
